import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from "@angular/router";
import {Observable, filter, first} from "rxjs";
import {ActivatedRoute} from "@angular/router";
import {HostingDomainsManageDNSComponent} from "./hosting-domains-manage-dns.component";
import {HostingService} from "../hosting.service";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {HostingDomainsZoneDataMapper} from "../domains/hosting-domains-zone-mapper";
import {HostingDomainsRecordMapper} from "../domains/hosting-domains-record-mapper";

@Injectable()
export class HostingDomainsManageDnsResolver implements Resolve<HostingDomainsManageDNSComponent|null> {

  constructor(
    private _hostingService: HostingService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const zoneId: number = route.params['zId'] || this.route.snapshot.data['myData'];
      this._hostingService.getZoneById(zoneId)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response) => {
          if (response.success) {
            const data = {
              records: response.data.records.map( (record) => HostingDomainsRecordMapper.map(record)),
              zone: HostingDomainsZoneDataMapper.map(response.data.zone)
            };
            resolve(data);
          }
          else {
            resolve(null);
            if (response.message === 'Zone not found') {
              this.router.navigate(['/404'], {skipLocationChange: true, replaceUrl: true});
            }
          }
        });

    });



  }

}
